import { TEntityListResponse, TDeviceTypeSummaryResBody } from '@poseidon-city/api-sdk';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TDeviceTypesListHook = {
  isError: boolean;
  isLoading: boolean;
  data: TEntityListResponse<'device-type', TDeviceTypeSummaryResBody> | undefined;
  refetch: () => void;
};

function useGetDeviceTypes(limit: number, page: number): TDeviceTypesListHook {
  const sdk = useApiSDK();
  const { i18n } = useTranslation();

  const { isError, isLoading, data, refetch } = useQuery({
    queryKey: ['device-types', page, limit, i18n.language],
    queryFn: async () => {
      const data = await sdk.deviceTypes.list(limit, page);
      return data;
    },
  });

  return { isError, isLoading, data, refetch };
}

export { useGetDeviceTypes };
